export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
};

export const getFileTypeFromMime = (mimeType: string): string => {
    if (mimeType.includes("png")) return "PNG";
    if (mimeType.includes("jpeg") || mimeType.includes("jpg")) return "JPG";
    if (mimeType.includes("webp")) return "WEBP";
    if (mimeType.includes("gif")) return "GIF";
    if (mimeType.includes("svg")) return "SVG";
    return mimeType.split("/")[1]?.toUpperCase() || "Unknown";
};
